<template>
    <div class="page-container">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive && hasPagePermission" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive && hasPagePermission" />
        <PermissonForbidden v-if="!hasPagePermission && !loading" />
        <CorpExpireMask v-else />
    </div>
</template>

<script>
import { Icon } from "vhtml-ui";
import { isPrivate } from "src/config/private";
import PermissonForbidden from "@/components/permisson-forbidden/index";
import CorpExpireMask from "src/components/corp-expire-mask";
import { envDomain } from '@/utils/domainConfig';

const req = require.context("./assets/icons", false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        PermissonForbidden,
        CorpExpireMask,
    },
    data() {
        return {
            hasPagePermission: false,
            loading: true,
        };
    },
    beforeRouteEnter(to, from, next) {
        if (to.hash.length) {
            const path = to.fullPath.replace(/#/g, "");
            next(path);
        } else {
            next();
        }
    },
    async created() {
        // 用于兼容内嵌页的样式
        const isUseCrossDomain =
            window.location.href.match(/useCrossDomain=(\d*)/);
        const useCrossDomain = isUseCrossDomain && isUseCrossDomain[1];
        if (useCrossDomain && !isPrivate) document.domain = "qidian.qq.com";
        await this.checkPagePermission();
    },
    methods: {
        async checkPagePermission() {
            try {
                this.loading = true;
                const res = await this.$ajax.crossGet(envDomain.gateway + "/v1/privilege/settings");
                const { code, message } = res;
                if (code !== 0)
                    return this.$message.error(
                        message || "获取权限异常，请稍后重试"
                    );
                const { role_editable_scope: scope } = res.data;
                // 2 仅限超级管理员操作 1 全部（无需处理） --tapd:https://tapd.woa.com/tapd_fe/10109441/story/detail/1010109441121367219
                if (scope !== 2) {
                    this.hasPagePermission = true;
                }
            } catch (err) {
                this.$message.error(
                    (err && err.message) || "获取权限异常，请稍后重试"
                );
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style lang="less">
@import "./style.less";
</style>
